export interface ErrorI {
  pin?: string | null;
  password?: string | null;
  confirmPassword?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  termsCondition?: string | null;
}

export const checkValidation = (data) => {
  const e: ErrorI = {};
  Object.keys(data).map((key) => {
    if (data[key].length) {
      e[key] = null;
    } else {
      e[key] = `${camelCaseToNormalString(upperCaseFirstLatter(key))} is required`;
    }
    return key;
  });

  if (data.confirmPassword !== data.password) {
    e.confirmPassword = "Password doesn't match";
  }

  return e;
};

const upperCaseFirstLatter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
const camelCaseToNormalString = (str: string) => {
  return str.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  });
};

export const getAccessToken = () => {
  const token = sessionStorage.getItem('access_token');
  if (token) return token;
  return localStorage.getItem('access_token');
};
